import r from"bignumber.js";function i(i){return r.isBigNumber(i)?i:new r(i.toString())}export{i as valueToLong};
//# sourceMappingURL=long.js.map
